import React, { useState, createContext } from "react";

export const AppContext = createContext();

const AppProvider = ({ children }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false); 

    const toggleMenu = () => setIsMenuOpen(prev => !prev);
    const closeMenu = () => {
        if (isMenuOpen) setIsMenuOpen(false);
    };

    const toggleDropdown = () => setIsDropdownOpen(prev => !prev);
    const closeDropdown = () => {
        if (isDropdownOpen) setIsDropdownOpen(false)
    };

    return (
        <AppContext.Provider
            value={{
                isMenuOpen,
                isDropdownOpen,
                toggleMenu, 
                closeMenu,
                toggleDropdown,
                closeDropdown,
            }}
        >
            {children}
        </AppContext.Provider>

    );
};


const RootElement = ({ children }) => (
    <AppProvider>
        {children}
    </AppProvider>
);

export default RootElement;
